import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { RestService } from '@app/core/rest.service';
import { LoadingService } from '@app/core/loading.service';
import { environment } from 'environments/environment';
import { SingpassInitResponse, CustomerProfile } from './models/singpass.model';
import * as moment from 'moment';

@Injectable()
export class SingpassService extends RestService {

  constructor(http: Http, loadingService: LoadingService) {
    super(http, loadingService);
    this.baseUrl = environment.infoUrl;
  }

  initLogin(tenantId: string, redirectUri: string): Observable<SingpassInitResponse> {
    const callback = redirectUri || (environment as any).singpassRedirectUri || 'https://api.access-my.app/api/SingPass/CallBack';
    return this.post('/init', {
      redirectUri: callback,
      tenantId,
      campaignId: '',
      purpose: 'KYC MyInfo',
      origin: window.location.href
    }).pipe(
      map(res => ({
        authorizationUrl: res.authorizationUrl || res.AuthorizationUrl,
        sessionId: res.sessionId || res.SessionId
      } as SingpassInitResponse))
    );
  }

  getOneTimeToken(id: string): Observable<any> {
    return this.get(`/onetoken/${encodeURIComponent(id)}`);
  }

  getMyInfo(accessToken: string): Observable<CustomerProfile | null> {
    return this.post('/myinfo', {
      accessToken: accessToken
    }).pipe(
      map((res: any) => {
        if (!res) return null;

        // migrate or normalize incoming data into CustomerProfile
        const legacy = (res as any).Profile || {};
        res.CustomerProfile = res.CustomerProfile || {};

        const source = Object.keys(res.CustomerProfile).length ? res.CustomerProfile : legacy;
        const fullName = (res.CustomerProfile.FullName || source.FullName || source.Name || '').toString();

        res.CustomerProfile.FullName = res.CustomerProfile.FullName || fullName;
        res.CustomerProfile.FirstName = res.CustomerProfile.FirstName;
        res.CustomerProfile.LastName = res.CustomerProfile.LastName;
        res.CustomerProfile.Email = res.CustomerProfile.Email || source.Email;
        const rawMobile = res.CustomerProfile.MobileNumber || source.MobileNumber || source.MobileNo;
        const normalizedMobile = this.normalizeMobile(rawMobile);
        if (normalizedMobile) {
          res.CustomerProfile.MobileNo = normalizedMobile;
        } else {
          res.CustomerProfile.MobileNo = res.CustomerProfile.MobileNo || source.MobileNumber || source.MobileNo;
        }
        res.CustomerProfile.UinFin = res.CustomerProfile.UinFin || source.UinFin;
        const rawDob = legacy.DateOfBirth || res.CustomerProfile.DateOfBirth;
        res.CustomerProfile.DateOfBirth = this.normalizeDob(rawDob);
        res.CustomerProfile.Nationality = res.CustomerProfile.Nationality || source.Nationality;

        return res.CustomerProfile as CustomerProfile;
      })
    );
  }

  private normalizeMobile(input: any): string | undefined {
    if (!input) return undefined;
    const s = input.toString().trim();
    let cleaned = s.replace(/[^\d+]/g, '');
    if (cleaned.startsWith('+')) cleaned = cleaned.substring(1);
    if (cleaned.startsWith('00')) cleaned = cleaned.replace(/^0+/, '');
    let digits = cleaned.replace(/[^\d]/g, '');
    if (!digits) return undefined;
    if (digits.startsWith('65') && digits.length > 8) {
      digits = digits.replace(/^65/, '');
    }
    return digits;
  }

  private normalizeDob(input: any): string | undefined {
    if (!input) return undefined;
    const s = input.toString().trim();
    let m = (moment as any)(s, 'YYYY-MM-DD', true);
    if (!m.isValid()) m = (moment as any)(s, 'DD/MM/YYYY', true);
    if (!m.isValid()) m = (moment as any)(s);
    if (!m.isValid()) return undefined;
    return m.format('YYYY-MM-DD');
  }
}


// WEBPACK FOOTER //
// ./src/app/core/singpass.service.ts